import React from "react";

const Section = ({ title, action, children, testId }) => (
  <section data-testid={testId} className="mb-10 fade-up">
    <div className="flex items-end justify-between mb-4 px-1">
      <h2 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight">{title}</h2>
      {action}
    </div>
    {children}
  </section>
);

export default Section;
